import { Box, Icon, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { FilterButtonProps } from "./type"
import { icons } from "../../../../../../utils/icons"
import { useTranslation } from "react-i18next"

function FilterButton(props: FilterButtonProps) {
    const { t } = useTranslation()
    const styles = useStyles()
    return (
        <Box {...props} className="btn-effect" sx={styles.container}>
            <Icon sx={styles.icon}>{icons('tune')}</Icon>

            <Typography>{t('general.filters')}</Typography>
        </Box>
    )
}

export default FilterButton